import React, { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import UsersListRow from './UsersListRow';
import InviteUsersForm from './InviteUsersForm';

import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableHead, TableHeader, TableRow, TableCell } from '../ui/table';
import { Spinner } from '../ui/spinner';

const UsersListTable = ({ branding, sortedUserList, adminUser, showLoader, canManage }) => {
  const [showInviteUserForm, setShowInviteUserForm] = useState(false);
  const { body } = branding.fonts?.[0].font || {};

  return (
    <div className='w-full' style={{ fontFamily: body }}>
      <Card className='border rounded-md'>
        <CardHeader className='flex flex-row items-center justify-between pb-2'>
          <CardTitle className='uppercase text-xl font-semibold'>Your Users</CardTitle>
          {!showLoader && branding && branding?.inviteUsers && canManage && (
            <Button
              id='invite-user-button'
              onClick={() => setShowInviteUserForm(!showInviteUserForm)}
              className='font-semibold text-base bg-secondary text-secondary-foreground hover:text-primary-foreground'>
              Invite User
            </Button>
          )}
        </CardHeader>
        <CardContent className='p-0'>
          {showLoader ? (
            <div className='mt-4 w-full flex items-center justify-center p-8'>
              <Spinner size='large' />
            </div>
          ) : (
            <div className='overflow-x-auto m-4'>
              <Table className='w-full' id='users-table'>
                <TableHeader>
                  <TableRow>
                    <TableHead>Name</TableHead>
                    <TableHead>Email</TableHead>
                    {adminUser && <TableHead>Status</TableHead>}
                    {canManage && <TableHead className='text-center'>Action</TableHead>}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {Array.isArray(sortedUserList) &&
                    sortedUserList
                      .filter((userDetails) => userDetails != null)
                      .map((userDetails, index) => (
                        <UsersListRow key={index} userDetails={userDetails} adminUser={adminUser} />
                      ))}
                  {sortedUserList?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} className='text-center font-semibold text-base'>
                        No users available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>

      {showInviteUserForm && (
        <InviteUsersForm setShowInviteUserForm={setShowInviteUserForm} showInviteUserForm={showInviteUserForm} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { cyfAdmin, whiteLabelAdmin, consultantAdmin } = state?.profile?.details || {};
  const adminUser = cyfAdmin || whiteLabelAdmin || consultantAdmin;

  const sortedUserList =
    state.organisation &&
    state.organisation.users &&
    _.uniqBy(state.organisation.users, 'sub').sort((a, b) => a?.name?.localeCompare(b?.name));

  return {
    currentOrganisation: state.currentOrganisation,
    branding: state.branding,
    sortedUserList,
    adminUser,
    showLoader: state?.showLoader,
    canManage: !!state?.organisation?.permissions?.organisation?.manage,
  };
};

export default connect(mapStateToProps)(UsersListTable);
